export default __webpack_public_path__ + "static/media/mallory_compact_book.f8c46a8d.ttf";